import React, { Fragment } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { setActivitiesSet } from "../Store/entities/book";
import { setActivitiesSet as setActivitySetApi } from "../Store/api/activities";
import { copyBulk, byBook } from "../Store/api/activities";

const ActivitySetModal = (props) => {
  const dispatch = useDispatch();
  const { book } = useSelector((state) => state.entities);
  return (
    <Modal
      show={props.show}
      onHide={(e) => {
        props.setActivitySetModal({ show: false, choice: "" });
      }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      className="choice-modal"
      centered
    >
      <Modal.Header closeButton className="choice-modal-header"></Modal.Header>
      <Modal.Body className="choice-modal-body">
        <h4>
          {props.options.choice === "original"
            ? "good choice!"
            : "get creative!"}
        </h4>
        <p>
          {props.options.choice === "original" ? (
            "View, edit and assign the activities that the author has created to be used with this book. You can still create your own at any time!"
          ) : (
            <Fragment>
              Start exploring activities on greyled! You can still view and use
              the activities created by the author in the <u> Linked to book</u>{" "}
              tab.
            </Fragment>
          )}
        </p>
      </Modal.Body>
      <Modal.Footer className="choice-modal-footer">
        <Button
          style={{ marginBottom: "12px" }}
          className="btn get-started"
          onClick={() => {
            dispatch(
              setActivitySetApi({
                onSuccess: (res) => {
                  dispatch(setActivitiesSet(props.options.choice));
                },
                onError: (error) => {
                  window.alert("Something went wrong!");
                },
                body: { activitiesSet: props.options.choice },
                id: book._id,
              })
            );
            if (props.options.choice === "original") {
              dispatch(
                copyBulk({
                  body: { bookId: book._id },
                  onSuccess: (res) => {
                    dispatch(
                      byBook({
                        id: book._id,
                        onSuccess: (res) => {},
                      })
                    );
                  },
                  onError: (err) => {
                    alert(err.response.data.message);
                  },
                })
              );
            }
            props.setActivitySetModal({ show: false, choice: "" });
            if (props.options.choice !== "original") {
              props.setCreatingActivity(true);
            }
          }}
        >
          Get started
        </Button>
        <Button
          className="btn go-back"
          onClick={() => {
            props.setActivitySetModal({ show: false, choice: "" });
          }}
        >
          Go back
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ActivitySetModal;
